
/*
|
|--------------------------------------------------------------------------
| Barba Delete Cache
|--------------------------------------------------------------------------
| Sometimes there are pages that should not be loaded from the barba
| cache. The script below deletes the cache for pages once you leave
|
*/

//--------------------------------------------------------------------------
// URLs to delete Cache
//--------------------------------------------------------------------------
// list out the page pathname you want reloaded
let domainName = window.location.origin;
let cacheToDelete = [
    domainName + '/cart/'
];

//------------------------------------------------------------------------------
// Grab raw HTML and process <script> elements before it's added to the page
//------------------------------------------------------------------------------

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container,newPageRawHTML) {

    flushCash(oldStatus);

});

function flushCash(oldStatus){
    if ( cacheToDelete.indexOf(oldStatus.url) > -1){
        delete Barba.Pjax.Cache.data[oldStatus.url];

    }
}



